import { registry, instancePerContainerCachingFactory } from 'tsyringe';
import {
  kNameOfCondition,
  ICondition,
} from '../services/promotion-recommendation-service/conditions/interfaces/condition.interface';
import { ConditionPromotionPreviouslyDisplayed } from '../services/promotion-recommendation-service/conditions/condition-promotion-previously-displayed';
import { ConditionGameInfoReceived } from '../services/promotion-recommendation-service/conditions/condition-game-info-received';
import { ConditionPromotionCTAClicked } from '../services/promotion-recommendation-service/conditions/condition-promotion-cta-clicked';
import { ConditionGeoRestricted } from '../services/promotion-recommendation-service/conditions/condition-geo-restricted';
import { ConditionPromotionOfferDismissed } from '../services/promotion-recommendation-service/conditions/condition-promotion-offer-dismissed';
import { ConditionPromotionOfferApproved } from '../services/promotion-recommendation-service/conditions/condition-promotion-offer-approved';
import { ConditionCooldownFromLastPromotion } from '../services/promotion-recommendation-service/conditions/condition-cooldown-last-promotion';
import { GlobalConditionOfferApprovalRequired } from '../services/promotion-recommendation-service/conditions/condition-offer-approval-required';
import { GlobalConditionInGameRecommendationsDisabled } from '../services/promotion-recommendation-service/conditions/condition-in-game-recommendations-disabled';

@registry([
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(GlobalConditionInGameRecommendationsDisabled);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(GlobalConditionOfferApprovalRequired);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionPromotionOfferDismissed);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionPromotionOfferApproved);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionCooldownFromLastPromotion);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionPromotionPreviouslyDisplayed);
    }),
  },

  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionPromotionCTAClicked);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionGeoRestricted);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionGameInfoReceived);
    }),
  },
])
export class ConditionsRegistry {}
